import { create, tsx } from '@dojo/framework/core/vdom';
import * as css from './ConnectStrip.m.css';
import { ConnectButton } from './ConnectButton';
import ContentWrapper from './ContentWrapper';

import Text from './Text';
import { RenderResult } from '@dojo/framework/core/interfaces';

interface ConnectStripChildren {
	title?: RenderResult;
	blurb?: RenderResult;
}

interface ConnectStripProperties {
	to?: string;
	trailing?: boolean;
}

const factory = create()
	.properties<ConnectStripProperties>()
	.children<ConnectStripChildren | undefined>();

const defaultTitle = "We'd love to hear from you!";
const defaultBlurb = `Whether you need help with a current or upcoming project, initial advice
and consultation, or just want to introduce yourself.`;

export const ConnectStrip = factory(function ConnectStrip({ children, properties }) {
	const { to, trailing } = properties();
	const [connectChildren = { title: defaultTitle, blurb: defaultBlurb }] = children();
	const { title = defaultTitle, blurb = defaultBlurb } = connectChildren;

	return (
		<ContentWrapper>
			<div classes={[css.root, trailing && css.trailing]}>
				<div classes={css.title}>
					<Text type="callout-head" responsive="section" align="center">
						{title}
					</Text>
				</div>
				<h3 classes={css.blurb}>{blurb}</h3>
				<ConnectButton to={to} />
			</div>
		</ContentWrapper>
	);
});

export default ConnectStrip;
